export const consolelog = (message,printData,show)=>{
    try{
        if(show){
            console.log(message,printData)
        }
    }catch(err){
        console.log(err,"consolelog__err")
    }
}